import { styled as i, modifier as o, css as e } from "@lokalise/styled";
import { value as r } from "../../utils/theme/index.js";
const d = i.span`
	display: flex;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	padding: 0 0 0 1px;
`, n = i.button`
	position: relative;
	display: inline-block;
	padding: 4px 7px 8px;
	height: 30px;
	z-index: 1;
	vertical-align: middle;
	margin: 0 0 0 -1px;
	cursor: pointer;

	background: transparent;
	border: 1px solid ${r("color.border.active")};
	font-size: 20px;
	color: ${r("color.text.link.default")};

	${o(
  "$selected",
  e`
			z-index: 2;

			background: ${r("color.background.action.primary.default")};
			color: ${r("color.text.inverse")};
		`
)}

	&:first-child {
		border-radius: ${r("radius.m")} 0 0 ${r("radius.m")};
	}
	&:last-of-type {
		border-radius: 0 ${r("radius.m")} ${r("radius.m")} 0;
	}

	&:hover,
	&:focus {
		background-color: ${r("color.background.surface.fore")};
		${o(
  "$selected",
  e`
				background: ${r("color.background.action.primary.default")};
			`
)};
	}
`;
export {
  n as Button,
  d as Container
};
//# sourceMappingURL=styles.js.map
